import { render, staticRenderFns } from "./matrix-upload-no-action.vue?vue&type=template&id=0a6fd78a&scoped=true"
import script from "./matrix-upload-no-action.vue?vue&type=script&lang=js"
export * from "./matrix-upload-no-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fd78a",
  null
  
)

export default component.exports